import { Expose, Type } from '@nts/std/serialization';
import { LayoutDefinitionIdentity } from "../layout/layout-definition.identity";
import { LayoutDefinitionIdentityInterface } from '@nts/std/interfaces';

export class GridUserLayoutIdentityDto {
    @Expose()
    gridFullPathName: string

    @Expose()
    @Type(() => LayoutDefinitionIdentity)
    layoutIdentity: LayoutDefinitionIdentityInterface;

    @Expose()
    serviceFullName: string;
}
